import {
  DELETE_TIMER,
  DELETE_TIMER_SUCCESS,
  INIT_TIMER,
  INIT_TIMER_SUCCESS,
  LOAD_TIMELOGS,
  LOAD_TIMELOGS_SUCCESS,
  START_TIMER,
  START_TIMER_SUCCESS,
  STOP_TIMER,
  STOP_TIMER_SUCCESS,
  UPDATE_TIME,
  UPDATE_TIME_SUCCESS,
  LOAD_TASK_TIMELOGS,
  LOAD_TASK_TIMELOGS_SUCCESS,
  DELETE_TIMER_GROUP,
  DELETE_TIMER_GROUP_SUCCESS,
  UPDATE_TIME_GROUP_SUCCESS,
  SET_TIMER_STARTED_SOCKET,
  SET_TIMER_STOPPED_SOCKET,
  UNSUBSCRIBE_TIMER_STOPPED,
  SUBSCRIBE_TIMER_STARTED,
  UNSUBSCRIBE_TIMER_STARTED,
  SUBSCRIBE_TIMER_STOPPED,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { showErrorMessage } from '../../helpers/utilHelpers';

// Action for send request on server that the get timer
export const initTimer = () => {
  return {
    type: INIT_TIMER,
    payload: {
      resource: 'timer',
      onSuccess: initTimerSuccess,
    },
  };
};
const initTimerSuccess = (values) => {
  return {
    type: INIT_TIMER_SUCCESS,
    values,
  };
};

// Action for send request on server that the start timer
export const startTimer = (taskId) => {
  return {
    type: START_TIMER,
    payload: {
      taskId,
      resource: 'timer/start',
      onSuccess: startTimerSuccess,
    },
  };
};
const startTimerSuccess = (values) => {
  return {
    type: START_TIMER_SUCCESS,
    values,
  };
};

// Action for send request on server that the stop timer
export const stopTimer = () => {
  return {
    type: STOP_TIMER,
    payload: {
      resource: 'timer/stop',
      onSuccess: stopTimerSuccess,
    },
  };
};
const stopTimerSuccess = (values) => {
  return {
    type: STOP_TIMER_SUCCESS,
    values,
  };
};

// Action for send request on server that the delete timer
export const deleteTimer = (payload = {}) => {
  return {
    type: DELETE_TIMER,
    payload: {
      resource: 'timer',
      onSuccess: deleteTimerSuccess,
      entityId: payload.taskId,
      ...payload,
    },
  };
};
const deleteTimerSuccess = (timeId) => {
  return {
    type: DELETE_TIMER_SUCCESS,
    timeId,
  };
};

// Action for send request on server that the delete timer
export const deleteTimerGroup = (timerIds) => {
  return {
    type: DELETE_TIMER_GROUP,
    payload: {
      resource: 'timer/delete-group',
      onSuccess: deleteTimerGroupSuccess,
      timerIds,
    },
  };
};
const deleteTimerGroupSuccess = (timers) => {
  return {
    type: DELETE_TIMER_GROUP_SUCCESS,
    timers,
  };
};

// Action for send request on server that the create time
export const createTime = (values, payload = {}, settings = {}) => {
  return {
    type: UPDATE_TIME,
    payload: {
      resource: 'timer/create',
      onSuccess: updateTimeSuccess,
      ...payload,
    },
    ...settings,
    values,
  };
};

// Action for send request on server that the update time
export const updateTime = (payload = {}) => {
  return {
    type: UPDATE_TIME,
    payload: {
      resource: 'timer',
      extraFields: ['taskTotalTime', 'taskTotalRate'],
      onSuccess: updateTimeSuccess,
      entityPrimaryKey: 'timeId',
      onErrorFunction: (status, data) => showErrorMessage(data?.description?.message),
      ...payload,
    },
    values: payload.values,
  };
};
const updateTimeSuccess = (values) => {
  return {
    type: UPDATE_TIME_SUCCESS,
    values,
  };
};

export const updateTimeGroupSuccess = (values) => {
  return {
    type: UPDATE_TIME_GROUP_SUCCESS,
    values,
  };
};

// Action sends request to fetch timelogs for a specified task
export const loadTimelogs = (payload = {}) => {
  return {
    type: LOAD_TIMELOGS,
    payload: {
      resource: 'timer/list',
      onSuccess: loadTimelogsSuccess,
      onErrorMessage: getIntlMessage('timer.load.error'),
      ...payload,
    },
  };
};
const loadTimelogsSuccess = (timelogs) => {
  return {
    type: LOAD_TIMELOGS_SUCCESS,
    timelogs,
  };
};

// Action sends request to fetch timelogs for a specified task
export const loadTaskTimelogs = (taskId, page) => {
  return {
    type: LOAD_TASK_TIMELOGS,
    payload: {
      resource: 'timer/task-time-list/' + taskId,
      onSuccess: loadTaskTimelogsSuccess,
      onErrorMessage: getIntlMessage('timer.load.error'),
      page,
    },
  };
};
const loadTaskTimelogsSuccess = (timelogs) => {
  return {
    type: LOAD_TASK_TIMELOGS_SUCCESS,
    timelogs,
  };
};

export const setTimerStartedSocket = (values) => {
  return {
    type: SET_TIMER_STARTED_SOCKET,
    values,
  };
};

export const setTimerStoppedSocket = (values) => {
  return {
    type: SET_TIMER_STOPPED_SOCKET,
    values,
  };
};

export const subscribeTimerStarted = () => {
  return {
    type: SUBSCRIBE_TIMER_STARTED,
  };
};

export const unsubscribeTimerStarted = () => {
  return {
    type: UNSUBSCRIBE_TIMER_STARTED,
  };
};

export const subscribeTimerStopped = () => {
  return {
    type: SUBSCRIBE_TIMER_STOPPED,
  };
};

export const unsubscribeTimerStopped = () => {
  return {
    type: UNSUBSCRIBE_TIMER_STOPPED,
  };
};
